import styled from "styled-components";

export const BodyContainer = styled.div`
    width: 100%;
    height: 100%;;
`;